module.exports = __webpack_public_path__ + "static/img/Vector2.66113307.svg";